import * as React from "react";
import * as cn from "classnames";

const Styles = require("./styles.scss");
type LinesProps = {
    orientation?: "horizontal" | "vertical"
}
export const Line = (props: LinesProps) => <div className={Styles.component}>
    <div className={Styles[props.orientation || "horizontal"]}/>
</div>